export default __webpack_public_path__ + "static/media/cp_geo_gb.a9bd2845.svg";